import { Controller } from 'stimulus'
import Swiper, { Navigation, Scrollbar, Autoplay } from 'swiper/core';

Swiper.use([Navigation, Scrollbar, Autoplay]);

export default class extends Controller {
  static targets = ['container', 'slides', 'slide', 'next', 'prev', 'scrollbar', 'pagination']

  options() {
    const defaults = {
      autoplay: false,
      loop: true,
    }
    let options = {}
    const data_options = this.containerTarget.dataset
    if (data_options.autoplayDelay) options.autoplay = { delay: data_options.autoplayDelay }
    // navigation
    if (this.hasNextTarget && this.hasPrevTarget) {
      options.navigation = { nextEl: this.nextTarget, prevEl: this.prevTarget }
    }
    // scrollbar
    if (this.hasScrollbarTarget) {
      options.scrollbar = { el: this.scrollbarTarget, hide: false }
      options.slidesPerView = 'auto'
      options.spaceBetween = data_options.noSpaceBetween !== undefined ? 0 : 30
      options.loop = false
      options.freeMode = true
      options.mousewheel = true
    }
    // console.log(Object.assign(defaults, options))
    return Object.assign(defaults, options)
  }

  connect() {
    if (this.slideTargets.length === 0) {
      // If no slides are specified, assume the direct children are slides, and add classes
      Array.from(this.slidesTarget.children).forEach(child => child.classList.add('swiper-slide'))
    }
    this._swiper = new Swiper(this.containerTarget, this.options())
  }
}
